// Centralized verified business details for ProSolve Global Solutions Recovery Houses (PGSRH)
// NOTE: Only verified details from the existing site are used here. Do not invent new data.

export const DOMAIN = 'https://pgsrh.com';

export const BRAND = {
  name: 'ProSolve Global Solutions Recovery Houses',
  shortName: 'PGSRH',
  legalName: 'ProSolve Global Solutions Recovery Houses',
  tagline: 'DDAP Licensed Recovery Residences',
  descriptor:
    'Safe, structured recovery housing for men and women rebuilding their lives in the Lehigh Valley, Pennsylvania.',
  generalPhone: '610-443-0175',
  menPhone: '570-579-7695',
  womenPhone: '610-443-0175',
  email: 'Admin@prosolveglobalsolutions.com',
  region: 'Lehigh Valley, Pennsylvania',
  ddapLine: 'DDAP Licensed Recovery Residences',
};

export const DEFAULT_OG_IMAGE = DOMAIN + '/og-default.jpg';

// Verified active locations only.
export const LOCATIONS = {
  Whitehall: {
    key: 'Whitehall',
    label: 'Whitehall, PA',
    gender: 'men',
    street: '855 3rd Street',
    city: 'Whitehall',
    state: 'PA',
    zip: '18052',
    phone: '570-579-7695',
    hasStreet: true,
  },
  Catasauqua: {
    key: 'Catasauqua',
    label: 'Catasauqua, PA',
    gender: 'women',
    street: '425 Walnut Street',
    city: 'Catasauqua',
    state: 'PA',
    zip: '18032',
    phone: '610-443-0175',
    hasStreet: true,
  },
};

// Existing live routes that must be preserved / linked
export const LEGACY_ROUTES = {
  home: '/',
  mensRecovery: '/mens-recovery',
  womensRecovery: '/womens-recovery',
  apply: '/apply',
  testimonials: '/testimonials',
  donations: '/donations',
  contact: '/contact',
};
